import React, { useEffect } from "react";
import { Container, Paper, Typography, CardContent, CardHeader } from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useVerifyEmailQuery } from "../apis/users";
import { useAppDispatch } from "../hooks/useRedux";
import { setToken } from "../redux/reducers/auth";

const VerifyToken = ({ signupVerifyToken }: { signupVerifyToken: string }) => {
  const navigate = useNavigate();
  const { data } = useVerifyEmailQuery({ signupVerifyToken });
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (data) {
      dispatch(setToken(data.token));
      navigate("/clients");
    }
  }, [data, dispatch, navigate]);

  return null;
};

const Verify = () => {
  const [searchParams] = useSearchParams();
  const { state } = useLocation();
  const email = state?.email as string | undefined;
  const signupVerifyToken = searchParams.get("signupVerifyToken");

  if (signupVerifyToken) {
    return <VerifyToken signupVerifyToken={signupVerifyToken} />;
  }

  return (
    <Container maxWidth="sm">
      <Paper sx={{ p: 2 }}>
        <CardHeader title="Check your email" />
        <CardContent>
          <Typography>
            Check your {email} inbox for instructions from us on how to verify your account.
          </Typography>
        </CardContent>
      </Paper>
    </Container>
  );
};

export default Verify;
